import * as React from 'react'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import StatusTooltip from 'modules/documents/components/DocumentPreview/Content/Esignature/StatusTooltip'
import StatusItem, {
  StatusStruct,
} from 'modules/documents/components/DocumentPreview/Content/StatusItem'
import type { EsignatureSignature } from 'modules/esignatures/hooks/signatures/useGetEsignatureSignatures'
import { SignatureStatuses } from 'modules/esignatures/lib/signatures/signatureStatuses'

interface Props {
  signature: EsignatureSignature
  order?: number
}

const toStatusStruct = (signature: EsignatureSignature): StatusStruct => {
  const status = signature.status as SignatureStatuses
  const isWaiting = status === SignatureStatuses.Waiting

  return {
    signerFullName: signature.signee.fullName,
    signerAvatar: signature.signee.avatar ? signature.signee.avatar : '',
    description: signature.data ? signature.data : '',
    statusText: isWaiting ? undefined : getStatusText(status),
    statusDate: isWaiting ? undefined : signature.registeredAt,
    statusDescription: isWaiting
      ? i18n.t('documents.modal.esignature.status_date_waiting', {
          date: moment(signature.registeredAt).format('ll'),
        })
      : undefined,
  }
}

const getStatusText = (status: SignatureStatuses): string => {
  return {
    [SignatureStatuses.Created]: i18n.t('documents.modal.esignature.status.sent'),
    [SignatureStatuses.Waiting]: i18n.t('documents.modal.esignature.status.waiting'),
    [SignatureStatuses.Signed]: i18n.t('documents.modal.esignature.status.signed'),
    [SignatureStatuses.Declined]: i18n.t('documents.modal.esignature.status.declined'),
    [SignatureStatuses.Bounced]: i18n.t('documents.modal.esignature.status.sent'),
    [SignatureStatuses.Cancelled]: i18n.t('documents.modal.esignature.status.cancelled'),
  }[status]
}

const SignatureBox = ({ signature, order }: Props) => {
  return (
    <StatusItem
      status={toStatusStruct(signature)}
      statusBox={<StatusTooltip signature={signature} />}
      order={order}
    />
  )
}

export default SignatureBox
